import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { getS3FileUrlByKey } from '../../services/appService';
import { getGptAlarmTypes } from '../../services/gptService';
import { gptAlarmTypeIconsState, gptAlarmTypesState } from '../../storage/gptStates';

function GptAlarmTypesProvider() {
  const setAlarmTypes = useSetRecoilState(gptAlarmTypesState);
  const setAlarmTypeIcons = useSetRecoilState(gptAlarmTypeIconsState);

  useEffect(() => {
    const load = async () => {
      const { alarmTypes, error } = await getGptAlarmTypes();
      if (!error && alarmTypes) {
        setAlarmTypes(alarmTypes);
        const alarmsWithIcon = alarmTypes.filter((alarmType) => !!alarmType.iconKey);
        const promises = alarmsWithIcon.map((alarmType) => getS3FileUrlByKey(alarmType.iconKey!, false, true));
        const responses = await Promise.allSettled(promises);
        const iconsCatalog: { [key: number]: string } = {};
        responses.forEach((result, index) => {
          if (result.status === 'fulfilled') {
            const {
              value: { url, error },
            } = result;
            if (!error && url) {
              iconsCatalog[alarmsWithIcon[index].code] = url;
            }
          }
        });
        setAlarmTypeIcons(iconsCatalog);
      } else {
        setAlarmTypes(undefined);
      }
    };
    load();
  }, []);

  return null;
}

export default GptAlarmTypesProvider;
